import React from 'react'
import { ListButton, ShowButton, RefreshButton, TopToolbar, Toolbar, SaveButton, CreateButton } from 'react-admin'

export const EditActions = ({ basePath, data, resource, NoShowButton }) => {


    return (
        <TopToolbar>
            <CreateButton basePath={ basePath } />
            <ListButton basePath={ basePath } record={ data } />
            { !NoShowButton && (<ShowButton basePath={ basePath } record={ data } />) }
            <RefreshButton basePath={ basePath } record={ data } />

        </TopToolbar>
    )
};

export const EditToolbar = props => (
    <Toolbar { ...props } >
        <SaveButton />
    </Toolbar>
);